import { cn } from '@/lib/cn';

export function OrgProgressBar({ pct, className, barClassName = 'bg-[#ff5a1f]' }: { pct: number; className?: string; barClassName?: string }) {
  return (
    <div className={cn('h-1.5 w-full overflow-hidden rounded-full bg-[#ececec]', className)}>
      <div className={cn('h-full rounded-full', barClassName)} style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} />
    </div>
  );
}
